const facettedSearchWidget = require('../../_utilities/facettedsearchwidget');

(() => {
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        state = action.value;
        break;

      default:
        break;
    }

    return state;
  };

  window.swinger.app({
    type: 'movies',
    component: 'movies',
    reducer: reducer(),
  })
    .then(facettedSearchWidget('movies'))
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/movies/movies.js